import { render, staticRenderFns } from "./LostType.vue?vue&type=template&id=dc11ed42&scoped=true"
import script from "./LostType.vue?vue&type=script&lang=js"
export * from "./LostType.vue?vue&type=script&lang=js"
import style0 from "./LostType.vue?vue&type=style&index=0&id=dc11ed42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc11ed42",
  null
  
)

export default component.exports